import React, { useState, useMemo } from "react";
import { formatTableDate } from "../../../../atoms/Chart";

import "./gold-rate.m.css";
import { formatRate } from "../../util";

const HistoricalGoldRateTable = ({ historicalRate, defaultDays = 30 }) => {
  const [activeTab, setActiveTab] = useState(defaultDays);

  const enable21Carat = useMemo(() => historicalRate?.length > 0 && historicalRate?.[0]?.carat21 > 0, [historicalRate]);

  // Memoize filtered data - only recalculate when dependencies change
  const filteredData = useMemo(() => {
    if (!historicalRate || historicalRate.length === 0) return [];
    return historicalRate.slice(0, activeTab);
  }, [historicalRate, activeTab]);

  return (
    <div styleName="gold-table-container" id="historical-gold-rate-table">
      <div styleName="tabs-container">
        <button
          styleName={activeTab === 30 ? "tab-button active" : "tab-button"}
          onClick={() => setActiveTab(30)}
          aria-pressed={activeTab === 30}
        >
          30 Days
        </button>
        <button
          styleName={activeTab === 60 ? "tab-button active" : "tab-button"}
          onClick={() => setActiveTab(60)}
          aria-pressed={activeTab === 60}
        >
          60 Days
        </button>
        <button
          styleName={activeTab === 90 ? "tab-button active" : "tab-button"}
          onClick={() => setActiveTab(90)}
          aria-pressed={activeTab === 90}
        >
          90 Days
        </button>
      </div>
      <table styleName="gold-rate-exchange-table" style={{ marginTop: 0 }}>
        <thead>
          <tr>
            <th>Date</th>
            <th>24 Carat</th>
            <th>22 Carat</th>
            {enable21Carat && <th>21 Carat</th>}
            <th>18 Carat</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.length > 0 ? (
            filteredData.map((item) => (
              <tr key={item?.date}>
                <td>{formatTableDate(item?.date)}</td>
                <td>{formatRate(item?.carat24)}</td>
                <td>{formatRate(item?.carat22)}</td>
                {enable21Carat && <td>{formatRate(item?.carat21)}</td>}
                <td>{formatRate(item?.carat18)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={enable21Carat ? 5 : 4}>No data available.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default HistoricalGoldRateTable;
